
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/profile/[handle]",
      function () {
        return require("private-next-pages/profile/[handle].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/profile/[handle]"])
      });
    }
  